import React, {Component, createContext} from "react";

const FunctionBarContext = createContext();

export default FunctionBarContext;
